import { ResourceOptions } from 'react-admin';
import { Resources } from '../../resource';
import './init';

export { default as list } from './List';

export const name = Resources.healthCheckProxy;
export const options: ResourceOptions = {
  label: 'resource.healthCheckProxy',
};
